/** Dosya okuma/indirme yardımcıları. */

import { M } from "../dil";

/**
 * `Blob.text()` her ortamda yok (eski Safari, jsdom). FileReader'a düşerek
 * her yerde çalışır.
 */
export function readFileAsText(file: Blob): Promise<string> {
  if (typeof (file as Blob & { text?: unknown }).text === "function") {
    return file.text();
  }
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ""));
    reader.onerror = () => reject(reader.error ?? new Error(M.iceAktar.dosyaOkunamadi));
    reader.readAsText(file, "utf-8");
  });
}

/** Dosyanın baytları (kodlamayı çağıran çözer). `Blob.arrayBuffer()` yoksa FileReader. */
export function readFileAsBytes(file: Blob): Promise<Uint8Array> {
  if (typeof (file as Blob & { arrayBuffer?: unknown }).arrayBuffer === "function") {
    return file.arrayBuffer().then((b) => new Uint8Array(b));
  }
  return new Promise<Uint8Array>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(new Uint8Array(reader.result as ArrayBuffer));
    reader.onerror = () => reject(reader.error ?? new Error(M.iceAktar.dosyaOkunamadi));
    reader.readAsArrayBuffer(file);
  });
}

/** Blob'u indirilen dosyaya çevirir. Tarayıcıda gerçek indirme başlatır. */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.rel = "noopener";
    document.body.append(a);
    a.click();
    a.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}
